import { render, staticRenderFns } from "./DashboardFleetInventory.vue?vue&type=template&id=6e054194&scoped=true"
import script from "./DashboardFleetInventory.vue?vue&type=script&lang=js"
export * from "./DashboardFleetInventory.vue?vue&type=script&lang=js"
import style0 from "./DashboardFleetInventory.vue?vue&type=style&index=0&id=6e054194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e054194",
  null
  
)

export default component.exports